/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';

import {theme, paddings} from 'components/shared/theme';

const {
  colors,
  fontSizeS
} = theme;

export const RestrictedDiv = styled.default.div`
  display: flex;
  align-items: center;
  justify-content: start;
  word-wrap: break-word;
  &.full-width {
    width: 100%;
  }
  & div {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    & span {
      color: ${theme.primaryTextColor};
      display: none;
      cursor: pointer;
      outline: none;
    }
    .icon-button {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  &:hover {
    & span {
      display: block;
    }
  }
`;

export const TruncatedBlock = styled.default.p`
  overflow: hidden;
  padding: ${paddings.small} 0;
  text-overflow: ellipsis;

  &.truncated {
    white-space: nowrap;
  }
`;

export const MeasuringBlock = styled.default.p`
  position: fixed;
  visibility: hidden;
  opacity: 0;
  white-space: nowrap;
`;

export const RestrictedRowWrapper = styled.default.div`
  display: flex;
`;

export const RestrictedRowLabel = styled.default.div`
  width: 135px;
  display: flex;
  align-self: center;
  color: ${colors.gray300};
  font-size: ${fontSizeS};
  padding: ${paddings.small};

  a {
    margin: 0 0.25rem;
  }

  span {
    margin: 0 2px;
  }
`;

export const RestrictedRowText = styled.default.div`
  color: ${colors.gray300};
  font-size: ${fontSizeS};
  border-bottom: 1px solid ${colors.gray700};
  padding: ${paddings.small};
  width: calc(100% - 135px);

  a {
    color: ${theme.linkColor};
    overflow-wrap: anywhere;
    text-decoration: none;
    font-size: ${fontSizeS};
  }
`;